import { useTranslation } from 'react-i18next';

interface ParallaxSectionProps {
  imageUrl: string;
  translationKey: string;
  height?: string;
}

export function ParallaxSection({ imageUrl, translationKey, height = '400px' }: ParallaxSectionProps) {
  const { t } = useTranslation();

  return (
    <section
      className="bg-fixed bg-cover bg-center relative"
      style={{
        backgroundImage: `url('${imageUrl}')`,
        height,
      }}
    >
      <div
        className="absolute inset-0 flex items-center justify-center"
        style={{ backgroundColor: 'var(--overlay)' }}
      >
        <p
          className="text-foreground text-3xl font-light tracking-wide"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          {t(translationKey)}
        </p>
      </div>
    </section>
  );
}
